const devicesState = {
    carouselDevices: undefined,
    lockDevices: undefined,
    requestingCarouselDevices: false,
    requestingLockDevices: false,
    requestingSetCarouselDevice: false,
    requestingSetLockDevice: false
};
export default devicesState;
